import React, { useEffect, useRef, memo } from "react";
import { TubeCurve } from "./Spline";

// vpoints: [Vector3]
export const Line = memo(({ vpoints, color }) => {
  if (vpoints == null) return null;
  const ref = useRef();

  useEffect(() => {
    ref.current.geometry.setFromPoints(vpoints);
  }, [vpoints]);

  // renderOrderとdepthTestは最前面に表示するための設定
  return (
    <line renderOrder={1} ref={ref}>
      <bufferGeometry attach="geometry" />
      <lineBasicMaterial attach="material" color={color} depthTest={false} />
    </line>
  );
});

// vlines: [[Vector3]]
export const Lines = memo(({ vlines, color, no, colorHigh }) => {
  if (vlines == null) return null;
  var objects = [];
  for (var i = 0; i < vlines.length; i++) {
    var vpoints = vlines[i];
    if(no == i)
      objects.push(<TubeCurve key={i} vpoints={vpoints} radius={0.5} color={colorHigh} />);
      //objects.push(<Line key={i} vpoints={vpoints} color={colorHigh} />);
    else
      objects.push(<TubeCurve key={i} vpoints={vpoints} radius={0.5} color={color} />);
      //objects.push(<Line key={i} vpoints={vpoints} color={color} />);
  }

  return objects.length !== 0 ? (
    <React.Fragment>{objects}</React.Fragment>
  ) : null;
});
